// react and js
import fetch from "isomorphic-fetch";

// mui

// components

// hooks

// i18n
import i18n, { DEFAULT_LANGUAGE } from "../i18n";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
// All checkout API calls forward the active UI language so the backend can
// localise responses (legal copy, plan descriptions, etc.). The server
// ignores unknown keys today; this prepares the ground for server-side i18n.
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
async function backendRequest(backendUrl, sendData) {
  if (!navigator.onLine) return false;

  const payload = {
    ...sendData,
    language: (i18n && i18n.language) || DEFAULT_LANGUAGE,
  };

  try {
    return fetch(backendUrl, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`Status: ${res.status}: ${res.statusText}`);
      }
      return res.json();
    });
  } catch {
    return false;
  }
}

export default backendRequest;
